import { render, staticRenderFns } from "./DocumentsItem.vue?vue&type=template&id=9a14e1ae&scoped=true"
import script from "./DocumentsItem.vue?vue&type=script&lang=js"
export * from "./DocumentsItem.vue?vue&type=script&lang=js"
import style0 from "./DocumentsItem.vue?vue&type=style&index=0&id=9a14e1ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a14e1ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a14e1ae')) {
      api.createRecord('9a14e1ae', component.options)
    } else {
      api.reload('9a14e1ae', component.options)
    }
    module.hot.accept("./DocumentsItem.vue?vue&type=template&id=9a14e1ae&scoped=true", function () {
      api.rerender('9a14e1ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Documents/DocumentsItem.vue"
export default component.exports